
<style>
  button:active{
    background: #8bc34a;
    color: white;
  }
</style>
<h4 style="text-align: center">Batch Editing: </h4>



<div>

  <div style="height: 8em;
  overflow-y: auto; margin-bottom: 2em; padding: 1em;">
    <div *ngFor="let location of nameObjs; let indexOfElement = index;">
      <p style="text-align: left;
        font-size: 0.75em;
        letter-spacing: 0.02em;
        font-weight: 100;">{{location.street_address}} {{location.subdivision_name}} - {{location.lot}}</p>
    </div>
  </div>


<form  [formGroup] = "form" style="    display: flex;
flex-direction: column;">

<div>
  <div>
    <mat-form-field style="width:90%">

      <mat-label>Employee: {{employee_name}}</mat-label>
      <input  #technitian matInput  formControlName = "technitian" [matAutocomplete] = "employeeauto">
      <!-- <button *ngIf="this.employee_name.length > 0" matSuffix mat-icon-button aria-label="Clear" (click)="resetEmployeeName(this.data)">
        X
      </button>  -->
    </mat-form-field>
  </div>

  <div>
    <button style="height: 4em;
    border-radius: 7px;
    width: 8em;
    color: #424242;
    border: 0; margin-bottom: 2em;" (click)="setEmployee()"> Set Employee</button>
  </div>

  <mat-autocomplete #employeeauto = "matAutocomplete" (optionSelected) = "onSelectEmployee($event.option.value)" [displayWith]="displayFunctionEmployee">
    <mat-option *ngFor="let em of (employee$ | async)" [value]="em">
      <span>{{ em.employee_name}}</span>
    </mat-option>
  </mat-autocomplete>

  <p *ngIf="ptoWarning" style="color: red; font-size: 0.85em; padding: 0 1em 1em;">{{ ptoWarning }}</p>
</div>

<div *ngIf="showWarningDetails">
  <details style="padding-bottom: 2em;">
    <summary style="font-size: 1em;
    padding: 1em;">
      <svg style="height: 2em;
    color: red;" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
  <path stroke-linecap="round" stroke-linejoin="round" d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126ZM12 15.75h.007v.008H12v-.008Z" />
</svg>

    Click to see warnings regarding credentials. 
    </summary>
      <div><p *ngFor="let warning of warningsToShow" style="font-size: 0.75em">{{warning}}</p></div>
  </details>
</div>

  <div matRipple [matRippleDisabled]="true" #scheduledateRipple>

    <div>
      <mat-form-field>
        <mat-label>Schedule Date</mat-label>
        <input (dateChange)="onSelectDate('change', $event)" matInput formControlName = 'schedule_date' #scheddate [matDatepicker]="schedule_date" disabled>
        <mat-datepicker-toggle matSuffix [for]="schedule_date"></mat-datepicker-toggle>
        <mat-datepicker #schedule_date disabled="false"></mat-datepicker>

      </mat-form-field>
    </div>

    <div>
    <button style="height: 4em;
    border-radius: 7px;
    width: 8em;
    color: #424242;
    border: 0; " (click)="setDate(scheddate.value)"> Set Date</button>
    </div>

  </div>
  </form>

  <div>

    <!--close the dialog ref-->
    <button style="height: 4em;
    border-radius: 7px;
    width: 8em;
    color: white;
    background: #8bc34a;
    margin-top: 4em;
    border: 0;" [mat-dialog-close]="{}"
      > Close</button>
  </div>

</div>
